import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NavButtonComponent } from '../nav-button/nav-button';
import { ScrollToTopComponent } from '../scroll-to-top/scrollToTop';
import { I18nService } from '../../services/i18n.service';
import { AuthenticationService } from '../../services/authentication.service';
import { App_Routes } from '../../enums/router.enum';

@Component({
  selector: 'app-note-for-us-residents',
  imports: [NavButtonComponent, ScrollToTopComponent],
  templateUrl: './note-for-us-residents.html',
  styleUrl: './note-for-us-residents.scss',
})
export class NoteForUsResidentsComponent {
  private router = inject(Router);
  public i18n = inject(I18nService);
  private auth = inject(AuthenticationService);

  gotoLogin() {
    if (this.router.url.includes('settings')) {
      this.router.navigate([App_Routes.SETTINGS]);
    } else {
      this.router.navigate([App_Routes.LOGIN]);
    }
  }

  // isAuth is now a signal
  isAuth = signal(this.auth.isLoggedIn());
}
